<template>
  <div class="formal-filter">
    <a-input-search
      v-model:value="staffName"
      placeholder="请输入员工姓名"
      enter-button="搜索"
      size="large"
      @search="handleStaffName"
    />
    <div class="select-container">
      <a-select
        style="width: 140px; margin-right: 12px"
        placeholder="归属大区"
        size="large"
        :filter-option="filterOptionRegions"
        v-model:value="regionsValue"
        @change="handleHasRegions"
        :showSearch="true"
      >
        <template #suffixIcon><CaretDownOutlined /></template>
        <a-select-option
          v-for="(regions, index) in allRegions"
          :key="index"
          :value="regions.Val"
          :filterV="regions"
          >{{ regions.Key }}
        </a-select-option>
      </a-select>
      <a-select
        style="width: 140px"
        placeholder="归属公司"
        size="large"
        :filter-option="filterOptionCompany"
        v-model:value="companyValue"
        @change="handleHasCompany"
        :showSearch="true"
      >
        <template #suffixIcon><CaretDownOutlined /></template>
        <a-select-option
          v-for="company in allCompanies"
          :key="company.Val"
          :value="company.Val"
          :filterV="company"
          >{{ company.Key }}</a-select-option
        >
      </a-select>
      <a-select
        v-if="getHeadTitleTextShow"
        style="width: 140px; margin-left: 12px"
        placeholder="公司类型"
        :maxTagCount="2"
        v-model:value="companyType"
        @change="handleCompanyType"
        size="large"
      >
        <template #suffixIcon><CaretDownOutlined /></template>
        <a-select-option
          v-for="item in companyTypeList"
          :key="item.Val"
          :value="item.Val"
          >{{ item.Key }}</a-select-option
        >
      </a-select>
      <a-cascader
        v-if="getHeadTitleTextShow"
        class="citys"
        style="width: 140px; margin-left: 12px; font-size: 14px"
        v-model:value="LocationId"
        :options="citysList"
        placeholder="选定城市"
        expand-trigger="hover"
        pacement="bottomLeft"
        :display-render="displayRender"
        :props="{ emitPath: false, value: 'Id', label: 'Text' }"
        :fieldNames="{
          label: 'Text',
          value: 'Id',
          children: 'Childs',
        }"
        @change="citysChange"
      />
      <a-date-picker
        v-if="getHeadTitleTextShow"
        style="width: 177.5px; margin-left: 12px; height: 40px"
        valueFormat="YYYY-MM-DD"
        v-model:value="ExpectOpenStartTime"
        placeholder="预计开业开始时间"
        size="large"
        :showToday="true"
        @change="handleOpenStartTime"
      />
      <a-date-picker
        v-if="getHeadTitleTextShow"
        style="width: 177.5px; margin-left: 12px; height: 40px"
        valueFormat="YYYY-MM-DD"
        v-model:value="ExpectOpenEndTime"
        placeholder="预计开业结束时间"
        size="large"
        :showToday="true"
        @change="handleOpenEndTime"
      />

      <a-select
        v-if="getOtherHeadTitleText"
        style="width: 140px; margin-left: 12px"
        placeholder="审批事项"
        :maxTagCount="2"
        v-model:value="approvalMatters"
        @change="handleApprovalMatters"
        size="large"
      >
        <template #suffixIcon><CaretDownOutlined /></template>
        <a-select-option
          v-for="item in approvalMattersList"
          :key="item.Val"
          :value="item.Val"
          >{{ item.Key }}</a-select-option
        >
      </a-select>
      <a-select
        v-if="!getHeadTitleText && titleFlag !== '工商变更'"
        style="width: 140px; margin-left: 12px"
        placeholder="审批事项"
        :maxTagCount="2"
        v-model:value="approvalMatters"
        @change="handleApprovalMatters"
        size="large"
      >
        <template #suffixIcon><CaretDownOutlined /></template>
        <a-select-option
          v-for="item in approvalMattersList"
          :key="item.Val"
          :value="item.Val"
          >{{ item.Key }}</a-select-option
        >
      </a-select>
      <a-select
        v-if="!getHeadTitleTextShow && titleFlag !== '工商变更'"
        style="width: 140px; margin-left: 12px"
        placeholder="审批节点"
        :maxTagCount="2"
        v-model:value="approvalNode"
        @change="handleApprovalNode"
        size="large"
      >
        <template #suffixIcon><CaretDownOutlined /></template>
        <a-select-option
          v-for="item in approvalNodeList"
          :key="item.Val"
          :value="item.Val"
          >{{ item.Key }}</a-select-option
        >
      </a-select>
      <a-select
        v-if="getHeadTitleTextShow"
        style="width: 140px; margin-top: 16px"
        placeholder="审批状态"
        :maxTagCount="2"
        v-model:value="approvesStatus"
        @change="handleApprovesStatus"
        size="large"
      >
        <template #suffixIcon><CaretDownOutlined /></template>
        <a-select-option
          v-for="item in approvalStatusList"
          :key="item.Val"
          :value="item.Val"
          >{{ item.Key }}</a-select-option
        >
      </a-select>
      <a-select
        v-if="getOtherHeadTitleText"
        style="width: 140px; margin-left: 12px"
        placeholder="审批状态"
        :maxTagCount="2"
        v-model:value="approvesStatus"
        @change="handleApprovesStatus"
        size="large"
      >
        <template #suffixIcon><CaretDownOutlined /></template>
        <a-select-option
          v-for="item in approvalStatusList"
          :key="item.Val"
          :value="item.Val"
          >{{ item.Key }}</a-select-option
        >
      </a-select>
      <a-range-picker
        v-if="getHeadTitleText || titleFlag == '工商变更'"
        :class="
          titleFlag == '流程列表' ? 'liuchenRangeClass' : 'otherRangeClass'
        "
        valueFormat="YYYY-MM-DD"
        v-model:value="ApplyTimeArr"
        :placeholder="['申请开始时间', '申请结束时间']"
        @change="handleApplyTimeArr"
      />
      <a-select
        v-if="titleFlag == '工商变更'"
        style="width: 332px; margin-left: 12px"
        placeholder="变更内容"
        :maxTagCount="2"
        v-model:value="ChangeCodes"
        @change="handleChangeCodes"
        size="large"
        mode="multiple"
      >
        <template #suffixIcon><CaretDownOutlined /></template>
        <a-select-option
          v-for="item in ChangeContents"
          :key="item.Val"
          :value="item.Val"
          >{{ item.Key }}</a-select-option
        >
      </a-select>
    </div>
    <FilterConditionTag
      :filterCondition="getNameList"
      @handleCloseTag="handleCloseTag"
      @handleClear="handleClear(true)"
    />
  </div>
</template>
<script>
import {
  reactive,
  toRefs,
  onActivated,
  computed,
  defineComponent,
  onMounted,
  ref,
} from "vue";
import { message } from "ant-design-vue";
import { useRouter, useRoute } from "vue-router";
import {
  GetRegions,
  GetCompaniesByRegionId,
  getApproveNodeList,
  getCompanyBusinessSearch,
} from "@/api/api";
import FilterConditionTag from "@/components/FilterCondition/index.vue";
import { CaretDownOutlined } from "@ant-design/icons-vue";
export default defineComponent({
  props: {
    clearFlag: {
      type: Boolean,
      default: false,
    },
    titleFlag: {
      type: String,
      default: "",
    },
  },
  components: {
    FilterConditionTag,
    CaretDownOutlined,
  },
  setup(props, { emit }) {
    // 判断是哪个列表隐藏表头筛选项
    const getHeadTitleText = computed(() => {
      return props.titleFlag === "申请列表" || props.titleFlag === "流程列表";
    });
    const getHeadTitleTextShow = computed(() => {
      return props.titleFlag === "申请列表";
    });
    const getOtherHeadTitleText = computed(() => {
      return props.titleFlag === "流程列表";
    });
    const router = useRouter();
    const route = useRoute();
    const data = reactive({
      staffName: undefined,
      regionsValue: undefined,
      companyValue: undefined,
      fullWorkerStatus: undefined,
      companyType: undefined, // 公司类型
      approvalNode: undefined, // 审批节点
      approvalMatters: undefined, // 审批事项
      ExpectOpenStartTime: "", // 预计开业时间
      ExpectOpenEndTime: "",
      ApplyTimeArr:[],
      approvesStatus: undefined, // 审批状态
      companyTypeList: [], // 公司类型
      citysList: [], // 选定城市
      approvalStatusList: [], // 审批状态
      approvalMattersList: [], // 审批事项
      approvalNodeList: [], // 审批节点
      companys: [],
      checkedCityName: "",
      LocationId: "",

      getNameList: [],
      allRegions: [],
      allCompanies: [],
      regionsId: -10,
      nameList: [],
      filterForm: {
        PageIndex: 0,
        PageSize: 0,
        Key: "",
        RegionId: 0,
        CompanyId: 0,
        ApproveNode: 0,
        ApprovalMatters: 0,
        Approves: -1,
        ExpectOpenStartTime: "",
        ExpectOpenEndTime: "",
        CompanyType: "",
        ApplyTimeArr:[]
      },
      ChangeContents: [], //工商变更变更内容
      ChangeCodes: [], //工商变更
    });

    // 获取审批节点
    const getApproveNode = async () => {
      const param = {
        NodeType: props.titleFlag === "流程列表" ? 1 : 0,
      };
      const { Success, Data } = await getApproveNodeList(param);
      if (Success) {
        data.approvalNodeList = Data.ApproveNode;
        data.approvalMattersList = Data.ApprovalMatters;
        data.ChangeContents = Data.ChangeContents;
      }
    };
    getApproveNode();

    // 名字搜索
    const handleStaffName = (val) => {
      if (!val) return;
      const index = 0;
      changeTag(val, index);
      data.filterForm.Key = data.staffName;
      emit("DataSearch", data.filterForm);
    };
    const filterOptionRegions = (inp, option) => {
      return String(option.filterV.Key).includes(inp);
    };
    // 筛选归属大区
    const handleHasRegions = async (val) => {
      const checkRegions = data.allRegions.find((item) => item.Val === val);
      const index = 2;
      changeTag(checkRegions.Key, index);
      data.regionsValue = checkRegions.Key;
      data.regionsId = checkRegions.Val;
      // 归属大区改变后， 归属公司清空
      getCompaniesByRegionId(val);
      data.companyValue = undefined;
      const cIndex = data.getNameList.findIndex((item) => item.index == 1);
      cIndex !== -1 ? data.getNameList.splice(cIndex, 1) : "";
      data.filterForm.RegionId = data.regionsId;
      data.filterForm.CompanyId = data.companyValue;
      emit("DataSearch", data.filterForm);
    };
    // 刚进来的时候获取归属公司
    const getCompaniesByRegionId = async (val) => {
      const allCompanies = [];
      if (val) {
        data.companys.forEach((item) => {
          if (item.ParentId == val) {
            allCompanies.push(item);
          }
        });
        data.allCompanies = allCompanies;
      }
    };
    getCompaniesByRegionId();
    //筛选公司
    const handleHasCompany = async (val) => {
      const checkCompany = data.allCompanies.find((item) => item.Val === val);
      const index = 1;
      changeTag(checkCompany.Key, index);
      data.companyValue = val;
      data.filterForm.CompanyId = data.companyValue;
      emit("DataSearch", data.filterForm);
    };

    const filterOptionCompany = (inp, option) => {
      return String(option.filterV.Key).includes(inp);
    };
    // 改变公司类型
    const handleCompanyType = (val) => {
      const index = 3;
      data.companyType = val;
      const checkCompanyType = data.companyTypeList.find(
        (item) => item.Val === val
      );
      data.filterForm.CompanyType = Number(data.companyType);
      let statusName = [];
      data.nameList.forEach((item) => {
        val &&
          val.forEach((jtem) => {
            if (jtem == item.EssentialValue) {
              statusName.push(item.EssentialName);
            }
          });
      });
      data.filterForm.BusinessTypeIds = data.fullWorkerStatus;
      changeTag(checkCompanyType.Key, index);
      emit("DataSearch", data.filterForm);
    };
    // 选定城市
    const citysChange = (val, option) => {
      const index = 9;
      data.filterForm.LocationId = val && val[val.length - 1];
      data.checkedCityName = option && option[option.length - 1].Text;
      changeTag(data.checkedCityName, index);
      emit("DataSearch", data.filterForm);
    };
    const displayRender = (val) => {
      return val.labels[val.labels.length - 1];
    };
    // 改变审批状态
    const handleApprovesStatus = (val) => {
      data.approvesStatus = val;
      data.filterForm.Approves = Number(data.approvesStatus);
      const checkapprovesStatus = data.approvalStatusList.find(
        (item) => item.Val === val
      );
      const index = 6;
      changeTag(checkapprovesStatus.Key, index);
      emit("DataSearch", data.filterForm);
    };
    // 改变审批事项
    const handleApprovalMatters = (val) => {
      data.approvalMatters = val;
      const checkApprovalMattersMatters = data.approvalMattersList.find(
        (item) => item.Val === val
      );
      const index = 7;
      changeTag(checkApprovalMattersMatters.Key, index);
      data.filterForm.ApprovalMatters = Number(data.approvalMatters);
      emit("DataSearch", data.filterForm);
    };
    // 改变审批节点
    const handleApprovalNode = (val) => {
      data.approvalNode = val;
      const checkApprovalNode = data.approvalNodeList.find(
        (item) => item.Val === val
      );
      const index = 8;
      changeTag(checkApprovalNode.Key, index);
      data.filterForm.ApproveNode = Number(data.approvalNode);
      emit("DataSearch", data.filterForm);
    };
    // 改变变更内容
    const handleChangeCodes = (val) => {
      data.ChangeCodes = val;
      data.filterForm.ChangeCodes = data.ChangeCodes;
      const index = 11;
      let list = [];
      data.ChangeCodes.forEach((item) => {
        list.push(data.ChangeContents[item - 1].Key);
      });
      changeTag(list, index);
      emit("DataSearch", data.filterForm);
    };
    const changeTag = (val, timeIndex) => {
      const fintT = data.getNameList.findIndex(
        (item) => item.index === timeIndex
      );
      //工商变更内容多选下拉框
      // if (timeIndex == 11) {
      //   if (fintT > -1) {
      //   data.getNameList.splice(fintT, 1);
      //   }

      //   if (val.length) {
      //     data.getNameList.push({
      //       name: val.toString(),
      //       index: timeIndex,
      //     });
      //   }

      //   return;
      // }
      if (fintT > -1) {
        data.getNameList.filter((item, index) => {
          if (item.index === timeIndex) {
            if (val && val.length > 0) {
              item.name = val.toString();
            } else {
              data.getNameList.splice(index, 1);
            }
          }
        });
      } else {
        data.getNameList.push({
          name: val.toString(),
          index: timeIndex,
        });
      }
    };
    const handleCloseTag = async (tag, index) => {
      if (tag.index === 0) {
        data.staffName = undefined;
        data.filterForm.Key = "";
      }
      if (tag.index === 1) {
        data.companyValue = undefined;
        data.filterForm.CompanyId = data.companyValue;
      }

      if (tag.index === 2) {
        data.filterForm.RegionId = 0;
        data.regionsValue = undefined;
        data.allCompanies = data.companys;
        // getCompaniesByRegionId()
      }
      if (tag.index === 3) {
        data.companyType = undefined;
        data.filterForm.CompanyType = undefined;
      }
      if (tag.index === 5) {
        data.ExpectOpenStartTime = undefined;
        data.filterForm.ExpectOpenStartTime = "";
      }
      if (tag.index === 10) {
        data.ExpectOpenEndTime = undefined;
        data.filterForm.ExpectOpenEndTime = "";
      }
      if (tag.index === 6) {
        data.approvesStatus = undefined;
        data.filterForm.Approves = -1;
      }
      if (tag.index === 7) {
        data.approvalMatters = undefined;
        data.filterForm.ApprovalMatters = undefined;
      }
      if (tag.index === 8) {
        data.approvalNode = undefined;
        data.filterForm.ApproveNode = undefined;
      }
      if (tag.index === 9) {
        data.LocationId = undefined;
        data.filterForm.LocationId = "";
      }

      if (tag.index === 11) {
        data.ChangeCodes = undefined;
        data.filterForm.ChangeCodes = "";
      }
      if (tag.index === 12) {
        data.ApplyTimeArr = [];
        data.filterForm.ApplyTimeArr = [];
      }
      emit("DataSearch", data.filterForm);
      data.getNameList.splice(index, 1);
    };
    const handleClear = async (isSearch) => {
      data.regionsValue = undefined;
      data.regionsId = -10;
      data.approvalMatters = undefined;
      data.approvalNode = undefined;
      data.approvesStatus = undefined;
      data.companyType = undefined;
      data.LocationId = undefined;
      data.ExpectOpenStartTime = undefined;
      data.ExpectOpenEndTime = undefined;
      data.ApplyTimeArr = [];
      getSearchFilter();
      data.staffName = undefined;
      data.companyValue = undefined;
      data.getNameList = [];
      data.fullWorkerStatus = undefined;
      data.ChangeCodes = [];
      data.filterForm = {
        PageIndex: 0,
        PageSize: 0,
        Key: "",
        RegionId: 0,
        CompanyId: 0,
        ApproveNode: 0,
        ApprovalMatters: 0,
        Approves: -1,
        ExpectOpenStartTime: "",
        ExpectOpenEndTime: "",
        CompanyType: 0,
        ChangeCodes: [],
        ApplyTimeArr: [],
      };
      if (isSearch) {
        emit("DataSearch", data.filterForm);
      }
    };

    onActivated(() => {
      if (!route.meta.flag) {
        handleClear(false);
      } else {
        //保留筛选条件
      }
    });
    // 筛选时间
    const handleOpenStartTime = (dateString) => {
      data.ExpectOpenStartTime = dateString;
      const index = 5;
      data.filterForm.ExpectOpenStartTime = data.ExpectOpenStartTime;
      changeTag(dateString, index);
      emit("DataSearch", data.filterForm);
    };
    const handleOpenEndTime = (dateString) => {
      data.ExpectOpenEndTime = dateString;
      const index = 10;
      data.filterForm.ExpectOpenEndTime = data.ExpectOpenEndTime;
      changeTag(dateString, index);
      emit("DataSearch", data.filterForm);
    };
    const handleApplyTimeArr = (dateString) => {
      data.ApplyTimeArr = dateString;
      const index = 12;
      data.filterForm.ApplyTimeArr = data.ApplyTimeArr;
      changeTag(dateString, index);
      emit("DataSearch", data.filterForm);
    };

    // 获取搜索头部
    const getSearchFilter = async () => {
      const { Data, Success, Message } = await getCompanyBusinessSearch();
      if (Success) {
        data.companys = Data.Company;
        data.allCompanies = Data.Company;
        data.allRegions = Data.Region;
        data.citysList = Data.Citys;
        data.companyTypeList = Data.CompanyType;
        data.approvalStatusList = Data.Approves;
      } else {
        message.warning(Message);
      }
    };
    onMounted(() => {
      getSearchFilter();
    });
    return {
      getCompanyBusinessSearch, // 头部搜索
      getHeadTitleText,
      getOtherHeadTitleText,
      getHeadTitleTextShow,
      ...toRefs(data),
      changeTag,
      handleStaffName,
      filterOptionRegions,
      filterOptionCompany,
      handleHasRegions,
      handleHasCompany,
      handleCompanyType,
      handleCloseTag,
      handleClear,
      handleOpenStartTime,
      handleOpenEndTime,
      handleApplyTimeArr,
      handleApprovesStatus,
      handleApprovalMatters,
      handleApprovalNode,
      citysChange,
      displayRender,
      handleChangeCodes,
    };
  },
});
</script>
<style scoped lang='less'>
.formal-filter {
  background: #fff;
  padding: 24px;
  margin-top: 11px;
  margin-bottom: 16px;
  border-radius: 4px;
  :deep(.ant-input-lg) {
    font-size: 14px;
  }
  :deep(.ant-select-lg) {
    font-size: 14px;
  }
  :deep(.ant-picker-large .ant-picker-input > input) {
    font-size: 14px;
  }
  :deep(.ant-input-search-large .ant-input-search-button) {
    height: 37px;
    font-size: 14px;
  }
  .select-container {
    padding: 16px 0 0 0;
  }
}
.citys {
  :deep(.ant-select-selector) {
    height: 40px;
    display: flex;
    align-items: center;
  }
}
.liuchenRangeClass {
  // width: 240px;
  // margin-left: 12px;
  margin-top: 16px;
  height: 40px;
}
.otherRangeClass {
  // width: 240px;
  margin-left: 12px;
  // margin-top: 16px;
  height: 40px;
}
</style>